<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-lg-5 offset-lg-1">
                <template v-for="(item,key) in value.text">
                    <p 
                        class="content-text content-text--title"
                        v-if="item.type == 'heading'"
                        :key="key">
                        {{item.value.title}}
                    </p>

                    <p 
                        v-else-if="item.type == 'paragraph'" 
                        class="content-text" 
                        v-html="item.value"
                        :key="key"></p>

                    <p 
                        v-else-if="item.type == 'quote'"
                        class="content-text--spotlight"
                        v-html="item.value"
                        :key="key"></p>
                </template>
            </div>
            <div class="col-12 col-lg-6">
                <img class="small-image-bg" :src="image" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'

export default {
    name:'',
    props:['value'],
    data() {
        return {
            utils:utils,
            image: null
        }
    },
    mounted() {
        this.image = utils.image(this.value.image,704, 1040)
    }
}
</script>